import ButtonRoundedBase from './ButtonRoundedBase'

export default ButtonRoundedBase
